import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import BundleSellingPoint, { variants } from './BundleSellingPoint';

import Classes from './BundleSellingPoints.module.scss';

const BundleSellingPoints = () => {
  const i18n = useI18nContext();

  return (
    <div className={Classes.root}>
      <h2 className={Classes.sectionTitle}>{i18n.t('purchaseBundle.sellingPoints.sectionTitle')}</h2>
      <div className={Classes.parentWrap}>
        <div className={Classes.itemWrap}>
          <BundleSellingPoint
            variant={variants.shop}
            title={i18n.t('purchaseBundle.sellingPoints.shop.title')}
            description={i18n.t('purchaseBundle.sellingPoints.shop.description')}
          />
        </div>
        <div className={Classes.itemWrap}>
          <BundleSellingPoint
            variant={variants.statistics}
            title={i18n.t('purchaseBundle.sellingPoints.statistics.title')}
            description={i18n.t('purchaseBundle.sellingPoints.statistics.description')}
          />
        </div>
        <div className={Classes.itemWrap}>
          <BundleSellingPoint
            variant={variants.fastSales}
            title={i18n.t('purchaseBundle.sellingPoints.fastSales.title')}
            description={i18n.t('purchaseBundle.sellingPoints.fastSales.description')}
          />
        </div>
      </div>
    </div>
  );
};

export default BundleSellingPoints;
